@import "../../../conversational-search-partials/details-header/details-header.scss";
@import "../../../conversational-search-partials/item-tile/item-tile.scss";
@import "./product-hierarchy-suggestions.scss";

.conversational-search-messages-product-hierarchy {
  &__header {
    margin-bottom: 16px;
  }

  &-content {
    display: flex;
    flex-direction: column;

    &__summary {
      margin-bottom: 16px;
    }
  }
}
